export type Immutable<T> = T extends object ? { readonly [Key in keyof T]: Immutable<T[Key]> } : T;

/** Freeze parser-derived plain objects without recursing through authored variations. */
export function freezePgnFacts<T>(facts: T): Immutable<T> {
  const pending: unknown[] = [facts];
  while (pending.length > 0) {
    const value = pending.pop();
    if (typeof value !== "object" || value === null) continue;
    for (const child of Object.values(value)) pending.push(child);
    Object.freeze(value);
  }
  return facts as Immutable<T>;
}

/** Recognize the supported parser's PEG syntax failures; internal failures escape. */
export function isPgnSyntaxError(error: unknown): error is Error & {
  expected: unknown;
  found: unknown;
  location: unknown;
} {
  return error instanceof Error && error.name === "SyntaxError" &&
    "expected" in error && "found" in error && "location" in error;
}
